/**
 * Canonical JSON parse for persisted strings (e.g. localStorage).
 * Returns `fallback` when input is null/empty, malformed JSON, or not parseable.
 */
export function safeParseJson<T>(raw: string | null | undefined, fallback: T): T {
  if (raw == null || raw === '') return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}
